import React from 'react';
import KmoCta from '../KmoCta';
import MkPhone from '../MkPhone';
import MkReviewCard from '../MkReviewCard';
import kmoQuickLock from '../../../assets/images/mk/mk-kmo-quicklock-510x740.webp';
import { PLAY_FACTS } from '../../../marketing/facts';
import { REVIEWS } from '../../../marketing/reviews';

// B10 — the only place on /bring-me-back with numbers, and they are Keep Me Out's (labelled so).
const BmbPairKmo = ({ platform }) => (
  <section
    className="mk-pair section"
    id="keep-me-out"
    aria-labelledby="mk-pair-title"
    data-mk-block="kmo-pair"
  >
    <div className="container">
      <div className="section-inner">
        <div className="mk-card mk-pair__card reveal-from-bottom">
          <div className="mk-pair__text">
            <h2 id="mk-pair-title" className="mk-h2 mk-h2--sm">
              Need a harder stop? Pair it with Keep Me Out.
            </h2>
            <p className="mk-body">
              {`Keep Me Out locks your whole Android phone for the time you choose. It has ${PLAY_FACTS.downloads} downloads and ${PLAY_FACTS.ratings} ratings on Google Play.`}
            </p>
            <p className="mk-micro mk-pair__label">A Keep Me Out review</p>
            <MkReviewCard review={REVIEWS.stella} variant="compact" className="mk-review--inset" />
            <div className="mk-pair__cta">
              {platform === 'ios' ? (
                <p className="mk-platform-note">Keep Me Out is Android-only.</p>
              ) : (
                <KmoCta placement="bmb_pair" platform={platform} />
              )}
            </div>
          </div>
          <div className="mk-pair__visual" aria-hidden="true">
            <MkPhone src={kmoQuickLock} width={510} height={740} fade alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BmbPairKmo;
